<template>
  <div
    v-if="isMorePages"
    v-intersection-observer="[onIntersectionObserver, { rootMargin: '0px 0px 250px 0px' }]"
    class="osk-more-pages"
  >
    <UikitLoaderInner
      v-if="!isDesktop && loading"
      small
    />

    <UikitButton
      class="osk-more-pages__button"
      outline
      size="s"
      :loading="loading"
      @click="handleClick"
    >
      Показать еще
    </UikitButton>
  </div>
</template>

<script lang="ts" setup>
import { vIntersectionObserver } from '@vueuse/components';

const props = defineProps<{
  loading?: boolean
}>();

const emits = defineEmits<{
  (e: 'getNextPage', value: number): void,
}>();

const { isDesktop } = useUiBreakpoints();
const { moreCurrentPage, isMorePages } = useMorePagesData();

function handleClick() {
  emits('getNextPage', moreCurrentPage.value + 1);
}

function onIntersectionObserver([{ isIntersecting }]: IntersectionObserverEntry[]) {
  if (isDesktop.value) return;

  if (!isIntersecting || props.loading || !isMorePages.value) return;

  handleClick();
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-more-pages {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 20px;

  @include media-query(lg-and-up) {
    height: auto;
  }

  &__button {
    display: none;

    @include media-query(lg-and-up) {
      width: 188px;
      display: flex;
    }
  }
}
</style>
